import { observer } from "mobx-react";
import { Box, VStack } from "@chakra-ui/react";
import { Droppable } from "react-beautiful-dnd";
import { FormToolPageDroppableContainerEnum } from "enums/form-tool-page-droppable-container.enum";
import { FormToolPageSettingsEmptyList } from "../../../../../../../../components/FormTool/FormToolPageSettingsEmptyList";
import React, { FC, useMemo } from "react";
import { DraggableElement } from "components";
import { QuestionnaireLeadTypes } from "types/questionnaire-tool-page.type";
import { FormToolPageSettingsSelectedQuestionConfigurator } from "../../../../../../../../components/FormTool/FormToolPageSettingsSelectedQuestionConfigurator/FormToolPageSettingsSelectedQuestionConfigurator";
import { QuestionnaireToolPageWIPFormStore } from "../../stores/QuestionnaireToolPageWIPForm.store";

interface IProps {
  leadType: QuestionnaireLeadTypes;
  questionnaireToolPageWIPFormStore: QuestionnaireToolPageWIPFormStore;
}

export const QuestionnaireToolPageSettingsSelectedQuestionsList: FC<IProps> = observer(
  ({ leadType, questionnaireToolPageWIPFormStore }) => {
    const questionsOrder =
      questionnaireToolPageWIPFormStore.wipFormSchemaJS.order;

    const draggableElements = useMemo(() => {
      return questionsOrder.map((questionKey, index) => (
        <DraggableElement
          id={`${FormToolPageDroppableContainerEnum.SELECTED_QUESTIONS}:${leadType}:${questionKey}`}
          key={questionKey}
          index={index}
        >
          <FormToolPageSettingsSelectedQuestionConfigurator
            index={index}
            questionKey={questionKey}
            formToolPageWIPFormStore={questionnaireToolPageWIPFormStore}
          />
        </DraggableElement>
      ));
    }, [questionsOrder, leadType, questionnaireToolPageWIPFormStore]);

    return (
      <Box width={"100%"}>
        <Box pb={10}>
          <Box pb={"10px"} fontSize={"lg"} fontWeight={"bold"}>
            Questions
          </Box>
          <Box fontSize={"sm"} color={"leadpro.500"}>
            Here you can create and re-order your selection of lead form
            questions. In order to capture a lead, some questions are<br></br>{" "}
            marked as essential, and cannot be removed.{" "}
            <b>
              Begin by dragging and dropping a question type from the left
              panel.
            </b>
          </Box>
        </Box>
        <Box>
          <Droppable
            droppableId={`${FormToolPageDroppableContainerEnum.SELECTED_QUESTIONS}:${leadType}`}
          >
            {provided => (
              <VStack
                spacing={2}
                paddingBottom={!!draggableElements.length ? "250px" : "150px"}
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {!draggableElements.length && (
                  <FormToolPageSettingsEmptyList>
                    Drag the questions from the menu and drop them here.
                  </FormToolPageSettingsEmptyList>
                )}
                {draggableElements}
                {provided.placeholder}
              </VStack>
            )}
          </Droppable>
        </Box>
      </Box>
    );
  }
);
